/* tslint:disable:quotemark */
export default class StorageUtils {
    static convertSessionStorageStringToNumber(numberAsText) {
        return Number(numberAsText.replace('"', "").replace('"', ""));
    }
}
